module.exports = __webpack_public_path__ + "img/code.d74a5dd9.png";